export var storybookArgs = {
    type: {
        options: ["login", "register", "activate", "recover", "mailrecoverinfo", "forgotpassword"],
        control: { type: "select" }
    },
    enable_recover_password: { control: { type: "boolean" } },
    i18nlang: { control: { type: "text" } },
    disableregister: { control: { type: "boolean" } },
    logouri: { control: { type: "text" } },
    loginuri: { control: { type: "text" } },
    registeruri: { control: { type: "text" } },
    login: { action: "loginEvent" },
    register: { action: "registerEvent" },
    recoverOrActivate: { action: "recoverOrActivateEvent" },
    getProviderToken: { action: "recoverOrActivateEvent" },
    oauth2providers: { control: { type: "array" } },
    sessionkey: { control: { type: "text" } },
    redirectonlogin: { control: { type: "text" } },
    redirectoncreate: { control: { type: "text" } },
    activateuri: { control: { type: "text" } },
    recoveruri: { control: { type: "text" } },
    requestmethod: { control: { type: "text" } },
    appendqueryparams: { control: { type: "text" } },
    appendbodyparams: { control: { type: "text" } },
    passwordpattern: { control: { type: "text" } },
    recoverycode: { control: { type: "text" } },
    email: { control: { type: "text" } }
};
var cssVars = [
    { name: "--bs-primary", valueType: "color", theme: "bootstrap", defaultValue: "#07689f" },
    { name: "--bs-secondary", valueType: "color", theme: "bootstrap", defaultValue: "#c9d6df" },
    { name: "--bs-success", valueType: "color", theme: "bootstrap", defaultValue: "#11d3bc" },
    { name: "--bs-info", valueType: "color", theme: "bootstrap", defaultValue: "#a2d5f2" },
    { name: "--bs-warning", valueType: "color", theme: "bootstrap", defaultValue: "#ffc107" },
    { name: "--bs-danger", valueType: "color", theme: "bootstrap", defaultValue: "#f67280" },
];
export var cssParts = [];
export var htmlSlots = [
    {
        name: "header",
        description: ""
    },
];
export var i18nLanguages = [
    { lang: "it", language: "italian" },
    { lang: "en", language: "english" },
];
export var styleSetup = {
    vars: cssVars,
    parts: cssParts
};
var examples = [
    {
        name: "login",
        data: {
            type: "login",
            logouri: "https://upload.wikimedia.org/wikipedia/commons/a/af/Free_Content_Logo.svg"
        }
    },
    {
        name: "register",
        data: {
            type: "register",
            logouri: "https://upload.wikimedia.org/wikipedia/commons/a/af/Free_Content_Logo.svg"
        }
    },
    {
        name: "activate",
        data: {
            type: "activate",
            recoverycode: "testcode",
            logouri: "https://upload.wikimedia.org/wikipedia/commons/a/af/Free_Content_Logo.svg"
        }
    },
    {
        name: "recover",
        data: {
            type: "recover",
            logouri: "https://upload.wikimedia.org/wikipedia/commons/a/af/Free_Content_Logo.svg"
        }
    },
    {
        name: "LoginEn",
        data: {
            type: "login",
            i18nlang: "en",
            disableregister: true
        }
    },
    {
        name: "LoginItOnly",
        data: {
            type: "login",
            i18nlang: "it",
            disableregister: true
        }
    },
    {
        name: "LoginEnWithFetch",
        data: {
            type: "login",
            i18nlang: "en",
            loginuri: "https://kernel.free.beeceptor.com/login",
            registeruri: "https://kernel.free.beeceptor.com/register"
        }
    },
    {
        name: "LoginEnWithOauth",
        data: {
            type: "login",
            i18nlang: "en",
            loginuri: "https://kernel.free.beeceptor.com/login",
            registeruri: "https://kernel.free.beeceptor.com/register",
            oauth2providers: [
                {
                    provider: "google",
                    uri: "https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A//www.googleapis.com/auth/drive.metadata.readonly&include_granted_scopes=true&response_type=token&state=state_parameter_passthrough_value&redirect_uri=https%3A//oauth2.example.com/code&client_id=client_id"
                },
                { provider: "facebook", uri: "" },
                { provider: "twitter", uri: "" },
            ]
        }
    },
    {
        name: "forgotpassword",
        data: {
            enable_recover_password: true,
            type: "forgotpassword",
            logouri: "https://upload.wikimedia.org/wikipedia/commons/a/af/Free_Content_Logo.svg"
        }
    },
    {
        name: "mailrecoverinfo",
        data: {
            type: "mailrecoverinfo",
            logouri: "https://upload.wikimedia.org/wikipedia/commons/a/af/Free_Content_Logo.svg"
        }
    },
];
export var componentSetup = {
    definitions: null,
    storybookArgs: storybookArgs,
    styleSetup: styleSetup,
    author: null,
    contributors: [],
    owner: null,
    htmlSlots: htmlSlots,
    i18n: i18nLanguages,
    examples: examples,
    screenshots: [],
    licenses: [{ type: "Apache-2.0", path: "LICENSE.md", cost: 0, currency: "EUR" }],
    readmePath: "README.md",
    name: "hb-auth",
    category: "components",
    tags: ["components"],
    size: { layout: "fullscreen" },
    iifePath: "release/release.js",
    repoName: "@htmlbricks/hb-auth",
    version: null
};
//# sourceMappingURL=docs.js.map